module.exports = __webpack_public_path__ + "static/media/mc.acbf04f7.svg";